import $ from 'jquery';

const initCookieDisclaimer = function () {
    let dateNow = new Date();
    dateNow.setMonth(dateNow.getMonth() + 1);
    dateNow.setFullYear(dateNow.getFullYear() + 1);
    const CMS_COOKIE_USER_CONSENT = "user_consent";
    const CMS_SET_COOKIE_USER_CONSENT = "user_consent=true;path=/;expires=" + dateNow.toUTCString();

    var selectorDisclaimer = "#cookieDisclaimer";
    var cookieYetUpdated = false;

    // Function to get a cookie
    function getCookie(name) {
        var value = "; " + document.cookie;
        var parts = value.split("; " + name + "=");
        if (parts.length == 2) {
            return parts
                .pop()
                .split(";")
                .shift();
        }
        return "";
    }

    var cookieUserContent = getCookie(CMS_COOKIE_USER_CONSENT);

    if ((cookieUserContent == null) || (cookieUserContent === "")) {
        $("#cookieDisclaimer").show();

        // remove disclaimer and add cookie if click on all btn or link of the current page

        $('a, #cookieDisclaimer button').on('click', function(e) {
            e.preventDefault();
            var href = $(this).attr("href");
            document.cookie = CMS_SET_COOKIE_USER_CONSENT;
            $(selectorDisclaimer).hide();

            if (href) {
                window.location = href;
            }
        });

        $(window).on('scroll', function() {
            if (cookieYetUpdated) {
                return;
            }

            var scrollPosition = $(this).scrollTop();
            if (scrollPosition >= 5) {
                document.cookie = CMS_SET_COOKIE_USER_CONSENT;
                $(selectorDisclaimer).hide();
                cookieYetUpdated = true;
            }
        });
    }
};

export {initCookieDisclaimer};


// WEBPACK FOOTER //
// ./src/js/cms/util/cookie-disclaimer.js